export const getAgentAvailabilityDates = (state) => state.currentAgentUser.agentAvailabilityDates;
export const getAgentOnlineStatus = (state) => state.currentAgentUser.agentOnlineStatus;
export const getAgentAvailabilityMessage = (state) => state.currentAgentUser.agentAvailabilityMessage;
